import React from 'react'

const news1 = () => {
  return (
    <>
            <div className="audit-page">
          <section className="audit-cover">
             <div className="container">
                <div className="audit-cover-para">
                  <h1 style={{color: "#f1f1f1", fontSize: "42px"}}>Latest amendment as per MCA</h1>
                </div>
             </div>
          </section>
          <section className="audit-page-content container" style={{marginBottom: "40px"}}>
             <h5><strong>CLARIFICATION BY MCA:</strong></h5>
             

             <div className="serv">
               <div className='inclu1'>
                  <p> Amendment to Schedule III to the Companies Act, 2013 vide MCA Notification GSR. 207(E) dated 24th March 2021 mandates companies to round off the figures appearing in the Financial Statements depending upon their total income. However, if the companies provide absolute figures in e-forms ie. AOC-4 or MGT-7, the same shall not be treated as incorrect certification by the Professionals.</p>
                  
               </div>
               
             </div>
          </section>
      </div> 
    </>
  )
}

export default news1
